import styled from '@emotion/styled';

export const LegalPersonViewPageSection = styled.div`
  margin-bottom: 50px;
`;

export const LegalPersonViewBoxContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette?.brand?.gray[300]};
  display: flex;
  margin-top: 32px;
  min-height: 80px;
  align-items: center;
  padding: 20px 28px;
  border-radius: 10px;
  width: 100%;
`;

export const LegalPersonViewAddressContent = styled.div`
  
`;

export const LegalPersonViewAddressIcon = styled.div`
  padding-right: 28px;
`;
